import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo11/justicia7.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 3.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[2];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[3].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[3].path}`,
    titlePrev: `${modulo11.content[0].activities[1].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa la siguiente imagen.</li>
      </ul>
      <div className="row mb-3">
        <div className="col-12 col-lg-6 col-md-10 text-center">
          <img src={Imagen1} alt="Poder judicial" className="img-fluid" />
        </div>
      </div>

      <ul>
        <li>Muchas veces la justicia es representada por esta imagen.</li>
        <li>
          Piensa. ¿Por qué crees que aparece con una venda en los ojos,
          sosteniendo una balanza y una espada?
        </li>
      </ul>
      <textarea className="form-control" rows={3} />

      <GuiaDocente>
        <p>
          Aclare: la venda significa que la justicia trata por igual a todos sin
          importar quiénes son (raza, posición social, etc.); la espada
          representa la fuerza de la justicia; y la balanza, el equilibrio.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
